/**
 * Global nav based code that provides a
 * standard error message if it's needed
 *
 * @TODO Confirm if still in use and then
 * move to react.
 */

import $ from 'jquery'

const hasCSSTransition = document.body.style.transition === ''
const TIMEOUT = 25025

let $el, headerContainer

export function setupHeaderMessagingView() {
  $el = $('.js_loadErrorHeader')
  headerContainer = $el.find('.js_loadErrorHeaderContainer')

  // changes header from fixed to static to allow error message to be responsive.
  $el.parents('body').addClass('loadErrorNavTreatment')

  setTimeout(() => showError(), TIMEOUT)
}

function measureElHeight(element, callback) {
  // Quickly rendering to DOM to measure height and width.
  // Then, removing it.
  const elHeight = element.addClass('showEl').outerHeight()
  element.removeClass('showEl')

  callback(elHeight)
}

function showError() {
  const finishAnimation = () => {
    headerContainer
      .removeClass('loadErrorHeaderTransition')
      .addClass('autoHeight')
      .removeAttr('style')
  }

  $el.removeClass('hide')
  headerContainer.addClass('loadErrorHeaderTransition')

  measureElHeight(headerContainer.find('.loadErrorHeaderTable'), height => {
    // Wait for the animate class to be added
    setTimeout(() => headerContainer.height(height), 25)

    // Wait for the animation to finish and then
    // removes the classes and style needed for the animation when done
    // Either do this with the transitionend event or setTimeout
    // depending on the browser support
    if (hasCSSTransition) {
      headerContainer.one('transitionend', finishAnimation)
    } else {
      setTimeout(finishAnimation, 550) // The time to complete the animation
    }
  })
}
